import React, { useState } from 'react';
import { SalvButton, SalvCard, Size } from '@salvapp/ui-components';
import SetFinalRiskRangesModal from './SetFinalRiskRangesModal';

const FinalRiskRangeCard = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <SalvCard expansionOptions={{ isDefaultExpanded: false }}>
        <SalvCard.Header>Final Risk Ranges</SalvCard.Header>
        <SalvCard.Body>
          <SalvButton
            onClick={() => setShowModal(true)}
            size={Size.SMALL}
            label='Set Final Risk Ranges'
            variant={'text'}
          />
        </SalvCard.Body>
      </SalvCard>

      <SetFinalRiskRangesModal show={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default FinalRiskRangeCard;
